import { IAiBlackboxProps } from '../type'
import AccountingSalesReport from './AccountingSalesReport'

export default function getBibibopContent(
  contentPartName: string,
): React.FC<IAiBlackboxProps> | null {
  switch (contentPartName) {
    case 'bibibopAccountingSalesReport':
      return AccountingSalesReport
    default:
      return null
  }
}
